/** „Oferta łączona” as the API sends it. Fields marked `?` are absent for a role that may not see them (rule 7a). */

export type OfferState = 'robocza' | 'wyslana' | 'zaakceptowana';
export const OFFER_STATE_LABELS: Record<OfferState, string> = { robocza: 'robocza', wyslana: 'wysłana', zaakceptowana: 'zaakceptowana' };
export type DetailLevel = 'lines' | 'sections' | 'totals';
export const DETAIL_LABELS: Record<DetailLevel, string> = { lines: 'Szczegółowo', sections: 'Sekcjami', totals: 'Tylko sumy' };
export type OfferCategory = 'equipment' | 'people' | 'transport';
export type OfferDiscount = { kind: 'pct' | 'amount'; value: number };

export type OfferLine = { id: string; name: string; type: string; category: OfferCategory; quantity?: number; daysMilli?: number; unitPriceGrosze?: number; discountBp?: number; netGrosze?: number };
export type OfferSection = { id: string; name: string; kind: string; category: OfferCategory; netGrosze?: number; lines: OfferLine[] };
export type OfferEvent = {
  eventId: string;
  name: string;
  startsAt: string | null;
  endsAt: string | null;
  segments: Array<{ startsAt: string; endsAt: string }> | null;
  location?: string;
  locationAddress?: string;
  deleted: boolean;
  clientMismatch: boolean;
  quoteId: string | null;
  versionId: string | null;
  versionNumber: number | null;
  versionState: string | null;
  vatBp: number | null;
  hideZeroLines: boolean;
  sections: OfferSection[];
  equipmentGrosze?: number;
  peopleGrosze?: number;
  transportGrosze?: number;
  totalGrosze?: number;
};

export type OfferTotals = {
  equipmentGrosze: number;
  peopleGrosze: number;
  transportGrosze: number;
  equipmentDiscountGrosze: number;
  peopleDiscountGrosze: number;
  equipmentDiscountCapped: boolean;
  peopleDiscountCapped: boolean;
  computedNetGrosze: number;
  netGrosze: number;
  vatGrosze: number;
  grossGrosze: number;
  manual: boolean;
};

export type OfferVersion = {
  id: string;
  offerId: string;
  number: number;
  state: OfferState;
  detailLevel: DetailLevel;
  equipmentDiscount?: OfferDiscount;
  peopleDiscount?: OfferDiscount;
  vatBp: number;
  manualNetGrosze?: number | null;
  notes: string;
  sentAt: string | null;
  sentTo: string | null;
  decidedAt: string | null;
  decisionNote: string;
  version: number;
  live: boolean;
  editable: boolean;
  hiddenEvents: number;
  vatMismatch?: boolean;
  /** Review I4: accepted, but a quote of it was accepted later in another version. */
  superseded: boolean;
  /** Review I2: the previous version's manual net (a new version starts without one). */
  previousManualNetGrosze?: number | null;
  events: OfferEvent[];
  totals?: OfferTotals;
};

export type OfferRef = { id: string; clientId: string; clientName: string; name: string; createdBy: string; version: number };
export type OfferOf = { offer: OfferRef; versions: Array<{ id: string; number: number; state: OfferState; sentAt: string | null }>; current: OfferVersion };
export type OfferListRow = { id: string; clientId: string; clientName: string; name: string; number: number; versionId: string; state: OfferState; eventIds: string[]; eventCount: number; firstStartsAt: string | null; version: number };

export const OFFERS_KEY = ['quotes', 'offers'] as const;
